/**
 * Endereços dos outros produtos Pharu — FONTE ÚNICA.
 *
 * Mesma disciplina do `api.js`: ninguém lê `process.env` direto, para que
 * trocar um endereço seja mexer em um lugar só. A diferença é que aqui o
 * endereço aponta para FORA do ERP — outro produto, outro domínio, outra
 * sessão de navegador.
 *
 * O que decide se o link aparece NÃO é este arquivo: é o contrato. O
 * backend devolve `produtos_contratados` em `/api/me/permissoes`, vindo da
 * mesma função que monta o `aud` do token, e a sidebar esconde o item de
 * quem não contratou. Sem esse cuidado o ERP ofereceria uma porta que o
 * outro produto recusa com 401 — e a pessoa leria isso como sistema
 * quebrado, não como "não contratei este produto".
 *
 * Slugs iguais aos de `plataforma.models.PRODUTOS` no backend.
 */

export const PRODUTO_PHARUCUT = "pharucut";
export const PRODUTO_PHARUERP = "pharuerp";

// Domínio próprio, e não o endereço do CloudFront, pelo mesmo motivo do
// `api.js`: com o domínio no meio, trocar de servidor é DNS, não rebuild.
const FALLBACK_PHARUCUT = "https://cut.pharu.com.br";

export const PHARUCUT_URL = (
  process.env.REACT_APP_PHARUCUT_URL || FALLBACK_PHARUCUT
).replace(/\/$/, "");
